import Button from '../../../../components/ui/Button';
import './Header.scss';

const Header = ({ image }) => {
    const headerStyle = {
        backgroundImage: `url(${image})`,
    };

    return (
        <section class="Header__showdown" style={headerStyle}>
            <div class="container">
                <h1 class="heading heading--large heading--white">
                    DE ONTKNOPING
                </h1>
                <p class="text text--white">
                    De beslissende maanden van het seizoen zijn aangebroken. De
                    titelrace, promotie, degradatie, Europese tickets,
                    play-offs, Europese finales. Volg het allemaal live op ESPN.
                </p>
                <Button
                    link="#matches"
                    label="Bekijk wedstrijdoverzicht"
                    type="primary"
                    size="large"
                />
                <Button
                    link="/abonneren"
                    label="Volg het allemaal live"
                    type="primary"
                    size="large"
                />
            </div>
        </section>
    );
};

export default Header;
